import _defineProperty from "/home/kms-config/ikos-kms-v2/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/kms-config/ikos-kms-v2/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React, { forwardRef, useRef, cloneElement } from 'react';
import { isElement } from '@mantine/utils';
import { useMergedRef } from '@mantine/hooks';
import { getDefaultZIndex, useComponentDefaultProps } from '@mantine/styles';
import { TooltipGroup } from './TooltipGroup/TooltipGroup.js';
import { TooltipFloating } from './TooltipFloating/TooltipFloating.js';
import { useTooltip } from './use-tooltip.js';
import { TOOLTIP_ERRORS } from './Tooltip.errors.js';
import useStyles from './Tooltip.styles.js';
import { getFloatingPosition } from '../Floating/get-floating-position/get-floating-position.js';
import { OptionalPortal } from '../Portal/OptionalPortal.js';
import { Transition } from '../Transition/Transition.js';
import { Box } from '../Box/Box.js';
import { FloatingArrow } from '../Floating/FloatingArrow/FloatingArrow.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var defaultProps = {
  position: "top",
  refProp: "ref",
  withinPortal: false,
  inline: false,
  arrowSize: 4,
  arrowOffset: 5,
  arrowRadius: 0,
  arrowPosition: "side",
  offset: 5,
  transition: "fade",
  transitionDuration: 100,
  width: "auto",
  events: {
    hover: true,
    focus: false,
    touch: false
  },
  zIndex: getDefaultZIndex("popover"),
  positionDependencies: []
};
var _Tooltip = forwardRef(function (props, ref) {
  var arrowRef = useRef(null);
  var _a = useComponentDefaultProps("Tooltip", defaultProps, props),
    children = _a.children,
    position = _a.position,
    refProp = _a.refProp,
    label = _a.label,
    openDelay = _a.openDelay,
    closeDelay = _a.closeDelay,
    onPositionChange = _a.onPositionChange,
    opened = _a.opened,
    withinPortal = _a.withinPortal,
    radius = _a.radius,
    color = _a.color,
    classNames = _a.classNames,
    styles = _a.styles,
    unstyled = _a.unstyled,
    style = _a.style,
    className = _a.className,
    withArrow = _a.withArrow,
    arrowSize = _a.arrowSize,
    arrowOffset = _a.arrowOffset,
    arrowRadius = _a.arrowRadius,
    arrowPosition = _a.arrowPosition,
    offset = _a.offset,
    transition = _a.transition,
    transitionDuration = _a.transitionDuration,
    multiline = _a.multiline,
    width = _a.width,
    events = _a.events,
    zIndex = _a.zIndex,
    disabled = _a.disabled,
    positionDependencies = _a.positionDependencies,
    onClick = _a.onClick,
    onMouseEnter = _a.onMouseEnter,
    onMouseLeave = _a.onMouseLeave,
    inline = _a.inline,
    others = __objRest(_a, ["children", "position", "refProp", "label", "openDelay", "closeDelay", "onPositionChange", "opened", "withinPortal", "radius", "color", "classNames", "styles", "unstyled", "style", "className", "withArrow", "arrowSize", "arrowOffset", "arrowRadius", "arrowPosition", "offset", "transition", "transitionDuration", "multiline", "width", "events", "zIndex", "disabled", "positionDependencies", "onClick", "onMouseEnter", "onMouseLeave", "inline"]);
  var _useStyles = useStyles({
      radius: radius,
      color: color,
      width: width,
      multiline: multiline
    }, {
      name: "Tooltip",
      classNames: classNames,
      styles: styles,
      unstyled: unstyled
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx,
    theme = _useStyles.theme;
  var tooltip = useTooltip({
    position: getFloatingPosition(theme.dir, position),
    closeDelay: closeDelay,
    openDelay: openDelay,
    onPositionChange: onPositionChange,
    opened: opened,
    events: events,
    arrowRef: arrowRef,
    arrowOffset: arrowOffset,
    offset: offset + (withArrow ? arrowSize / 2 : 0),
    positionDependencies: [].concat(_toConsumableArray(positionDependencies), [children]),
    inline: inline
  });
  if (!isElement(children)) {
    throw new Error(TOOLTIP_ERRORS.children);
  }
  var targetRef = useMergedRef(tooltip.reference, children.ref, ref);
  return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(OptionalPortal, {
    withinPortal: withinPortal
  }, /* @__PURE__ */React.createElement(Transition, {
    mounted: !disabled && tooltip.opened,
    transition: transition,
    duration: tooltip.isGroupPhase ? 10 : transitionDuration
  }, function (transitionStyles) {
    var _a2, _b;
    return /* @__PURE__ */React.createElement(Box, __spreadValues(__spreadValues({}, others), tooltip.getFloatingProps({
      ref: tooltip.floating,
      className: classes.tooltip,
      style: __spreadProps(__spreadValues(__spreadValues({}, style), transitionStyles), {
        zIndex: zIndex,
        top: (_a2 = tooltip.y) != null ? _a2 : 0,
        left: (_b = tooltip.x) != null ? _b : 0
      })
    })), label, /* @__PURE__ */React.createElement(FloatingArrow, {
      ref: arrowRef,
      arrowX: tooltip.arrowX,
      arrowY: tooltip.arrowY,
      visible: withArrow,
      withBorder: false,
      position: tooltip.placement,
      arrowSize: arrowSize,
      arrowOffset: arrowOffset,
      arrowRadius: arrowRadius,
      arrowPosition: arrowPosition,
      className: classes.arrow
    }));
  })), cloneElement(children, tooltip.getReferenceProps(__spreadValues(_defineProperty(_defineProperty({
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onMouseMove: props.onMouseMove,
    onPointerDown: props.onPointerDown,
    onPointerEnter: props.onPointerEnter
  }, refProp, targetRef), "className", cx(className, children.props.className)), children.props))));
});
_Tooltip.Group = TooltipGroup;
_Tooltip.Floating = TooltipFloating;
_Tooltip.displayName = "@mantine/core/Tooltip";
var Tooltip = _Tooltip;
export { Tooltip };